var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopAlign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "top align"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1234 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5999 15L17.5999 4.8L13.1999 4.8L13.1999 15C13.1999 15.1105 13.2894 15.2 13.3999 15.2L17.3999 15.2C17.5104 15.2 17.5999 15.1105 17.5999 15ZM18.3999 4L12.3999 4L12.3999 15C12.3999 15.5523 12.8476 16 13.3999 16L17.3999 16C17.9522 16 18.3999 15.5523 18.3999 15L18.3999 4Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1235 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5999 19L9.5999 4.8L5.1999 4.8L5.1999 19C5.1999 19.1105 5.28944 19.2 5.3999 19.2L9.3999 19.2C9.51036 19.2 9.5999 19.1105 9.5999 19ZM10.3999 4L4.3999 4L4.3999 19C4.3999 19.5523 4.84762 20 5.3999 20L9.3999 20C9.95219 20 10.3999 19.5523 10.3999 19L10.3999 4Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 36 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8 4.4C21.8 4.62091 21.621 4.8 21.4 4.8H2.40005C2.17913 4.8 2.00005 4.62091 2.00005 4.4C2.00005 4.17909 2.17913 4 2.40005 4H21.4C21.621 4 21.8 4.17909 21.8 4.4Z",
    fill: "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopAlign);
export default __webpack_public_path__ + "static/media/top_Align.1441b942213aa17836cf2e03dcdf199c.svg";
export { ForwardRef as ReactComponent };